import { Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { ModalBodyClass } from '../../modals/modal-body';
import { Observable } from 'rxjs';
import { ZiroFormConfig } from '../../forms/ziro-forms-models';
import { DetailedModalComponent } from '../../modals/detailed-modal/detailed-modal.component';
import { ZiroFormStateService } from '../../forms/ziro-form-state.service';
import {
  DirectoryNumberRef,
  EndUser,
  TranslationPatternRef,
  VoicemailRef,
} from '../../shared/models/generated/ziroModels';
import { ToastService } from '../../shared/services/toast.service';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';
import { TranslateService } from '@ngx-translate/core';
import { ZiroDirectoryNumberFormComponent } from '../cisco/directory-number/directory-number-form.component';
import { catchError } from 'rxjs/operators';
import { ToastTypes } from '../../shared/services/abstract/toast.service.abstract';

export interface DirectoryNumberUpdate {
  dnRef: DirectoryNumberRef;
  translationPatterns: TranslationPatternRef;
  endUser: EndUser;
  vmRef: VoicemailRef;
}

@Component({
  selector: 'ziro-directory-number-detailed-modal',
  templateUrl: 'directory-number-detailed-modal.component.html',
  styleUrls: ['./directory-number-detailed-modal.component.scss'],
  standalone: false,
})
export class ZiroDirectoryNumberDetailedModalComponent extends ModalBodyClass implements OnInit {
  private modalComponent = inject<DetailedModalComponent<any>>(DetailedModalComponent);
  protected _ziroFormStateService: ZiroFormStateService;
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  @ViewChild(ZiroDirectoryNumberFormComponent) directoryNumberForm: ZiroDirectoryNumberFormComponent;
  @ViewChild('errorTemplate') errorTemplate: TemplateRef<any>;
  areFormsValid = true;
  isSaving = false;
  ziroIcons = ZiroIcons;
  modalProperties: any;
  areFormsValidSet = false;

  formConfig = {
    fields: {},
  } as ZiroFormConfig;

  ngOnInit(): void {
    this.modalProperties = this.modalComponent.modalViewProperties;
  }

  isFormValid(): boolean {
    this.areFormsValid = this.directoryNumberForm.areAllFormsValid();
    if (!this.areFormsValidSet) {
      this.directoryNumberForm.setFormsSubmittingState(true);
      this.areFormsValidSet = true;
    }
    return this.areFormsValid;
  }

  submit(): Observable<any> {
    this._ziroFormStateService.isSaveDisabled.next(true);
    const modalObs$ = new Observable<DirectoryNumberUpdate>((subscriber) => {
      this.directoryNumberForm.checkForDnVoicemailConflict();
      this.directoryNumberForm.isSaveComplete$.subscribe((isComplete) => {
        if (isComplete) {
          subscriber.next({
            dnRef: this.directoryNumberForm.dnRef,
            translationPatterns: this.directoryNumberForm.tpRef,
            endUser: this.directoryNumberForm.endUserUpdate.endUser,
            vmRef: this.directoryNumberForm.updatedVmRef,
          });
          subscriber.complete();
          this.toastService.push(
            ToastTypes.SUCCESS,
            this.ziroIcons.HASH,
            'tkey;shared.toast.save.success.title',
            `${this.translateService.instant('tkey;shared.service.extension.text')} -
                ${this.directoryNumberForm.dnDidSelectorFormEntity.directoryNumber.extension}`,
          );
        }
      });
    });

    return modalObs$.pipe(
      catchError((err) => {
        this._ziroFormStateService.isSaveDisabled.next(false);
        throw err;
      }),
    );
  }

  isLoadingDone(): void {
    this._ziroFormStateService.isSaveDisabled.next(false);
  }

  onCancelClicked(isClicked: boolean): void {
    if (isClicked) {
      this.modalComponent.resetButtonState();
    }
  }
}
